import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { 
  Layout, Container, SliderContainer, 
  // ReservedButton, OuterCardContainer, 
  // CompanyCard
} from "../../UserDashboard/styles";

// import { Layout, Container } from "../../MainEvents/CompanyLiveEvents/styles";
// import { SliderContainer } from "../../MainEvents/styles";
import {
  StarIconSmall,
  NewBackArrowIconEventPage,
  NewNextArrowIconEventPage,
} from '../../../utils/icons';

const NextArrow = ({ currentSlide, slideCount, onClick }) => {
  if (currentSlide === slideCount - 1) return null;
  return <div className="left-arrow slick-next" onClick={onClick} style={{ display: 'block' }} />;
};

NextArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

const PrevArrow = ({ currentSlide, onClick }) => {
  if (currentSlide === 0) return null;
  return <div className="left-arrow slick-prev" onClick={onClick} style={{ display: 'block' }} />;
};

PrevArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

const FeaturedSlider = ({ items, title, titleIcon, renderItem }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, setSliderRef] = useState(null);

  if (!items?.length) return null;

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    adaptiveHeight: true,
    nextArrow: <NextArrow currentSlide={currentSlide} slideCount={items.length} />,
    prevArrow: <PrevArrow currentSlide={currentSlide} />,
    beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
    responsive: [
      {
        breakpoint: 1252,
        settings: {
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: <NextArrow currentSlide={currentSlide} slideCount={items.length} />,
          prevArrow: <PrevArrow currentSlide={currentSlide} />,
        },
      },
      {
        breakpoint: 600,
        settings: {
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: <NextArrow currentSlide={currentSlide} slideCount={items.length} />,
          prevArrow: <PrevArrow currentSlide={currentSlide} />,
        },
      },
    ],
  };

  return (
    <Layout
      style={{ background: '#fff', border: '0.75px solid #DCDCDC' }}
      margin={"20px 0 5px 0"}
      padding={"20px 20px 30px 20px"}
      background={'#fff'}
    >
      <div className="headingMain">
        <div style={{ gap: "12px" }} className="heading">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {titleIcon || StarIconSmall("#184A61")}
          </div>
          {title}
        </div>
        {items.length > 1 ? (
          <div className="arrows">
            <div
              className="iconBackground"
              onClick={() => sliderRef?.slickPrev()}
              style={{
                opacity: currentSlide === 0 ? 0 : 1,
                cursor: currentSlide === 0 ? 'not-allowed' : 'pointer',
              }}
            >
              {NewBackArrowIconEventPage()}
            </div>
            <div className="text">
              {currentSlide + 1} / {items.length}
            </div>
            <div
              className="iconBackground"
              onClick={() => currentSlide < items.length - 1 && sliderRef?.slickNext()}
              style={{
                opacity: currentSlide === items.length - 1 ? 0 : 1,
                cursor: currentSlide === items.length - 1 ? 'not-allowed' : 'pointer',
              }}
            >
              {NewNextArrowIconEventPage()}
            </div>
          </div>
        ) : null}
      </div>
      <Container style={{border: "none",borderRadius:"8px",marginTop:"16px",height:"344px"}}>
        <SliderContainer display="flex" content="center" shadow="0px 8px 25px 0px #0D427040" style={{ paddingRight: "1px" }}>
          <Slider {...sliderSettings} ref={(slider) => setSliderRef(slider)}>
            {items.map((item, index) => (
              <div key={index} >
                {renderItem(item, index)}
              </div>
            ))}
          </Slider>
        </SliderContainer>
      </Container>
    </Layout>
  );
};

FeaturedSlider.defaultProps = {
  titleIcon: null,
};

FeaturedSlider.propTypes = {
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  titleIcon: PropTypes.node,
  renderItem: PropTypes.func.isRequired,
};

export default FeaturedSlider;
